import "reflect-metadata";
import { container } from "tsyringe";
import { GoogleMaps } from './modules/google.maps';
import { Filter } from './modules/filter'
import { Images } from './modules/images';

const images = container.resolve(Images)
const googleMaps = container.resolve(GoogleMaps)
const filter = container.resolve(Filter)